// @ts-ignore
// eslint-disable-next-line camelcase
__webpack_public_path__ = window['~hpe~'] && window['~hpe~'].root || '/js/';

// Initial ESL config
import 'core/config/esl.config';

import {onDocumentReady} from '@exadel/esl/modules/esl-utils/dom/ready';

import {ESLVSizeCSSProxy} from '@exadel/esl/modules/esl-utils/fixes/viewport';
import {ESLImageContainerMixin} from '@exadel/esl/modules/esl-image-utils/core';
import {HPEReducedMotionInit} from 'core/hpe-reduced-motion-init';
import {HPEMediaRestriction} from 'core/media.restriction';

import {HPEMedia} from 'core/media';

// used to define exact document size (--100vw/--100vh) in CSS
ESLVSizeCSSProxy.init();

HPEReducedMotionInit.init();
HPEMediaRestriction.init();

// Critical components registration
ESLImageContainerMixin.register();
HPEMedia.register();

// Fallback Media Providers
import 'core/providers/https-provider';
import '@exadel/esl/modules/esl-media/providers/iframe-provider';

// Raw-video provider: (for attract loop)
import '@exadel/esl/modules/esl-media/providers/html5/video-provider';

// ESL Media Mixins
onDocumentReady(() => import(/* webpackChunkName: "core/media.mixins" */'core/media.mixins'));
// ESL Media Providers
onDocumentReady(() => import(/* webpackChunkName: "core/media.providers" */'core/media.providers'));
// Media Tracker
onDocumentReady(() => import(/* webpackChunkName: "core/media.tracker" */'core/video-hva-tracker')
  .then(({HPEVideoHvaTracker}) => HPEVideoHvaTracker.register()));
